<template>
  <div class="confirmation-status">
    <b-alert v-if="status === 'ISSUED'" variant="success" show class="d-flex">
      <div>
        Abbiamo inviato un'email di conferma all'indirizzo
        <span class="semibold">{{ email }}</span>.
        In alcuni casi potrebbero essere necessari anche oltre 10 minuti dal
        momento del booking. Se non la trovi controlla anche la casella di spam.
        Se non hai ricevuto l'email di conferma contattaci al numero
        <span class="semibold">{{ phone_number }}</span> o all'indirizzo
        <span class="semibold">{{ email_support }}</span>.
      </div>
    </b-alert>
    <b-alert
      v-else-if="status === 'PENDING'"
      variant="warning"
      show
      class="d-flex"
    >
      <div>
        La prenotazione è definitivamente confermata solo nel momento in cui
        ricevi l'email di conferma che invieremo all'indirizzo
        <span class="semibold">{{ email }}</span>.
        In alcuni casi potrebbero essere necessari anche oltre 10 minuti dal
        momento del booking. Controlla anche la casella di spam. Se sei sicuro
        di non avere ricevuto l'email di conferma contattaci al numero
        <span class="semibold">{{ phone_number }}</span> o all'indirizzo
        <span class="semibold">{{ email_support }}</span>.
      </div>
    </b-alert>
    <b-alert
      v-else-if="status === 'NOTCONFIRMED'"
      variant="danger"
      show
      class="d-flex"
    >
      <div>
        Ci sono stati alcuni problemi nel confermare la tua prenotazione. Ti
        invitiamo a contattarci appena possibile per ottenere il supporto di un
        nostro consulente
        <span class="semibold">{{ phone_number }}</span> o all'indirizzo
        <span class="semibold">{{ email_support }}</span>.
      </div>
    </b-alert>
    <b-alert v-else variant="danger" show class="d-flex">
      <!-- UNKNOWN o altro-->
      <div>
        Lo stato di questa prenotazione richiede una verifica. Contattaci al numero
        <span class="semibold">{{ phone_number }}</span> o all'indirizzo
        <span class="semibold">{{ email_support }}</span>.
      </div>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: "confirmation-status",

  props: {
    // stato della prenotazione (ISSUED | PENDING | NOTCONFIRMED | altro)
    status: {
      type: String,
      default: "",
    },
    // email di conferma del beneficiario
    email: {
      type: String,
      default: "",
    },
    // recapiti dell'assistenza
    phone_number: {
      type: String,
      default: "",
    },
    email_support: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss">

  .confirmation-status {
    font-size: $font-size-md;

    .alert {
      padding: $grid-gutter-20;
      line-height: normal;
    }
  }
</style>